import React from 'react';
import DashEstablishmentContainer from 'modules/dashboard/_common/DashEstablishmentContainer';
import RestaurantMenuPage from 'modules/restaurant/menu/RestaurantMenuPage';

export default function DashRestaurantMenu() {
    return (
        <DashEstablishmentContainer title='Cardápio'>
            <RestaurantMenuPage />
        </DashEstablishmentContainer>
    );
}
